module.exports = __webpack_public_path__ + "static/media/cmms.742b8504.svg";